import { PopoverAnchor } from '@radix-ui/react-popover';

import {
  InputBox,
  InputError,
  InputLabel,
  InputProps,
  InputRoot,
} from '../Input';

type Props = InputProps;

const DropdownInput: React.FC<Props> = props => {
  const {
    className,
    'data-testid': dataTestId,
    elementSize = 'large',
    error,
    isErrorHidden,
    isErrorInitiallyHidden: isErrorSpaceNotReserved,
    label,
    tooltipLabel,
    isLabelHidden,
    icon,
    leading,
    trailing,
    isDisabled: isDisabledProp,
    isRequired: isRequiredProp,
    disabled,
    required,
    hasNoDisabledStyle,
    ...inputProps
  } = props;

  const isDisabled = disabled || isDisabledProp;
  const isRequired = required || isRequiredProp;

  const hasError = !!error;

  return (
    <InputRoot className={className} data-testid={dataTestId}>
      <InputLabel
        hasError={hasError}
        isDisabled={isDisabled && !hasNoDisabledStyle}
        isLabelHidden={isLabelHidden}
        label={label}
        tooltipLabel={tooltipLabel}
      />
      <PopoverAnchor asChild>
        <InputBox
          elementSize={elementSize}
          hasError={hasError}
          hasNoDisabledStyle={hasNoDisabledStyle}
          inputProps={{
            disabled: isDisabled,
            required: isRequired,
            'aria-label': label,
            ...inputProps,
          }}
          leading={leading || icon}
          trailing={trailing}
        />
      </PopoverAnchor>
      <InputError
        elementSize={elementSize}
        error={error}
        inputTestId={dataTestId}
        isErrorHidden={isErrorHidden}
        isErrorSpaceReserved={!isErrorSpaceNotReserved}
      />
    </InputRoot>
  );
};

export default DropdownInput;
